import { render } from "./sel-menu.vue?vue&type=template&id=53a01b94"
import script from "./sel-menu.vue?vue&type=script&lang=js"
export * from "./sel-menu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__